import { useState, useEffect } from "react";
import swal from "sweetalert2";
import { getRevenueReportData } from "../api/reportsAPI";
import ic_check_on from "../../assets/images/ic_check_on.png";
import golf_cart from "../../assets/images/golf_cart.png";
import golf_caddy from "../../assets/images/golf_caddy.png";
import moment from "moment";
import RevenueRateBar from "./revenueRateBar";

const RevenueReport = (props) => {
  const [selectedFromDate, setSelectedFromDate] = useState(moment().toDate());
  const [selectedToDate, setSelectedToDate] = useState(moment().toDate());
  const [isInit, setIsInit] = useState(true);
  const [bookingReport, setBookingReport] = useState(null);
  const [bookingTable, setBookingTable] = useState(null);
  const [bookingDetails, setBookingDetails] = useState({
    totalAmount: 0,
    totalTax: 0,
    finalAmount: 0,
    fromDate: "",
    toDate: "",
    total: 0,
    totalBooking: 0,
    type: "Total Bookings",
  });

  const [rateDetails, setRateDetails] = useState({});

  useEffect(() => {
    props.title("Revenue Report", "tee-revenue-report");

    $("#txtFromDate").datepicker({
      format: "dd-mm-yyyy",
      minDate: new Date(),
    });
    $("#txtFromDate").on("change", function (event) {
      setSelectedFromDate(event.target.value);
    });
    $("#txtToDate").datepicker({
      format: "dd-mm-yyyy",
      minDate: new Date(),
    });
    $("#txtToDate").on("change", function (event) {
      setSelectedToDate(event.target.value);
    });
    getTeeReport();
  }, []);

  useEffect(() => {
    if (!isInit) {
      fillTable();
    }
  }, [bookingReport]);

  useEffect(() => {
    if (
      bookingReport &&
      bookingReport.BookSheet &&
      bookingReport.BookSheet.length > 0
    ) {
      setBookingDetails({
        fromDate: moment(selectedFromDate, "DD-MM-YYYY").format("DD MMM, YYYY"),
        toDate: moment(selectedToDate, "DD-MM-YYYY").format("DD MMM, YYYY"),
        total: bookingReport.BookSheet.length,
        type: "Total Bookings",
      });
    } else {
      setBookingDetails({
        fromDate: moment(selectedFromDate, "DD-MM-YYYY").format("DD MMM, YYYY"),
        toDate: moment(selectedToDate, "DD-MM-YYYY").format("DD MMM, YYYY"),
        total: 0,
        type: "Total Bookings",
      });
    }
  }, [bookingReport]);

  const getTeeReport = async () => {
    try {
      swal.fire({
        titleText: "Loading",
        text: "Please Wait...",
        showConfirmButton: false,
        onOpen: () => {
          swal.showLoading();
        },
      });

      const response = await getRevenueReportData(
        moment(selectedFromDate, "DD-MM-YYYY").format("YYYY-MM-DD"),
        moment(selectedToDate, "DD-MM-YYYY").format("YYYY-MM-DD")
      );

      if (response) {
        const totals = response.BookSheet?.reduce(
          (acc, item) => {
            //data
            acc.totalGreenFee += item.TotalGreenFee || 0;
            acc.totalDiscount += item.DiscountAmount || 0;
            acc.totalCartFee += item.TotalCartFee || 0;
            acc.totalCaddyFee += item.TotalCaddyFee || 0;
            acc.totalAmount += item.FinalAmount || 0;
            return acc;
          },
          {
            totalGreenFee: 0,
            totalDiscount: 0,
            totalCartFee: 0,
            totalCaddyFee: 0,
            totalAmount: 0,
          }
        );

        setRateDetails(totals);
      }

      isInit
        ? setIsInit(false)
        : $("#tblTeeRevenueReport").KTDatatable().destroy();

      setBookingReport(response);
      
      swal.close();
    } catch (err) {
      swal.fire({
        icon: "error",
        titleText: err.message,
      });
    }
  };

  function fillTable() {
    swal.close();
    var check =
      '<img src="' +
      ic_check_on +
      '" style="height: 20px; width: 20px; float:right;"/>';
    var cart =
      '<img src="' +
      golf_cart +
      '" style="height: 22px; width: 22px; float:right; margin-left:5px"/>';
    var caddy =
      '<img src="' +
      golf_caddy +
      '" style="height: 20px; width: 20px; float:right; margin-left:5px"/>';

    // const bookingSheet = bookingReport.BookSheet;
    const bookingSheet = bookingReport?.BookSheet?.sort((a, b) => {
                const aDateTime = moment(`${a.BookDate} ${a.Slot}`, "YYYY-MM-DD HH:mm:ss h:mm A");
                const bDateTime = moment(`${b.BookDate} ${b.Slot}`, "YYYY-MM-DD HH:mm:ss h:mm A");
    
                const dateTimeDiff = aDateTime.diff(bDateTime);
                if (dateTimeDiff !== 0) return dateTimeDiff;
    
                return Number(a.TeeBox) - Number(b.TeeBox);
            }) || [];

    $.each(bookingSheet, function (index, element) {
      if (element.Player1Caddy == "Y") {
        element["Player1"] += caddy;
      }
      if (element.Player2Caddy == "Y") {
        element["Player2"] += caddy;
      }
      if (element.Player3Caddy == "Y") {
        element["Player3"] += caddy;
      }
      if (element.Player4Caddy == "Y") {
        element["Player4"] += caddy;
      }

      if (element.Player1Cart == "Y") {
        element["Player1"] += cart;
      }
      if (element.Player2Cart == "Y") {
        element["Player2"] += cart;
      }
      if (element.Player3Cart == "Y") {
        element["Player3"] += cart;
      }
      if (element.Player4Cart == "Y") {
        element["Player4"] += cart;
      }

      if (element.Player1IsPresent == "Y") {
        element["Player1"] += check;
      }
      if (element.Player2IsPresent == "Y") {
        element["Player2"] += check;
      }
      if (element.Player3IsPresent == "Y") {
        element["Player3"] += check;
      }
      if (element.Player4IsPresent == "Y") {
        element["Player4"] += check;
      }
    });

    const tblBookSheet = $("#tblTeeRevenueReport").KTDatatable({
      data: {
        saveState: false,
        source: bookingSheet,
      },
      layout: {
        scroll: false,
        footer: false,
      },
      sortable: false,
      pagination: false,
      search: {
        input: $("#generalSearch"),
      },
      columns: [
        {
          field: "BookDate",
          title: "Game Dt",
          width: 80,
          template: function (row) {
            if (row.BookDate == null) {
              return "";
            } else {
              return moment(row.BookDate).format("DD-MM-YYYY");
            }
          },
        },
        {
          field: "TransactionDate",
          title: "Bill Dt",
          width: 140,
          template: function (row) {
            if (row.TransactionDate == null) {
              return "";
            } else {
              return moment(row.TransactionDate).format("DD-MM-YYYY, h: mm a");
            }
          },
        },
        {
          field: "Slot",
          title: "Slot",
          width: 60,
        },
        { field: "SubCategoryName", title: "Category", width: 130 },
        { field: "MembershipNo", title: "Mem. No" },
        { field: "BookedBy", title: "BookedBy" },
        { field: "BillNo", title: "Bill No" , width: 140},
        { field: "TeeBox", title: "TeeBox", width: 45 },
        { field: "Hole", title: "Holes", width: 40 },
        { field: "TotalPlayer", title: "Players", width: 80 },
        { field: "CartCount", title: "No of Cart", width: 80 },
        { field: "TotalCartFee", title: "Cart Fee", width: 80 },
        { field: "CaddyCount", title: "No of Caddy", width: 80 },
        { field: "TotalCaddyFee", title: "Caddy Fee", width: 80 },
        { field: "TotalGreenFee", title: "Green Fee", width: 80 },
        { field: "CGST", title: "CGST", width: 80 },
        { field: "SGST", title: "SGST", width: 80 },
        { field: "DiscountAmount", title: "Discount Amt", width: 80 },
        { field: "FinalAmount", title: "Total Amt", width: 80 },
      ],
      rows: {
        autoHide: false,
      },
    });


    $("#root .kt-grid--hor").addClass("max-width100");
    $("#tblTeeRevenueReport .kt-datatable__table").addClass("overflow-x-auto");

    Config.Core.InitPopover();
    Config.Core.GrabAndScroll(".kt-datatable__table");

    const BookingTable = $(".kt-datatable__table").tableExport({
      formats: ["xlsx", "csv"],
      headers: true,
      filename: `${moment(selectedFromDate).format(
        "DD-MM-YYYY"
      )} - To - ${moment(selectedToDate).format(
        "DD-MM-YYYY"
      )} - Tee Revenue Report`,
    });

    setBookingTable(BookingTable);
    $(".tableexport-caption").addClass("hidden");
  }

  function exportSheet(type) {
    let fileName = `${moment(selectedFromDate, "DD-MM-YYYY").format(
      "DD-MM-YYYY"
    )} - To - ${moment(selectedToDate, "DD-MM-YYYY").format(
      "DD-MM-YYYY"
    )} - Booking Revenue Report`;
    bookingTable.update({
      headers: true,
      formats: ["xlsx", "csv"],
      filename: fileName, // pass in a new set of properties
    });

    if (type == "xlsx") {
      $(".button-default.xlsx").click();
    } else {
      $(".button-default.csv").click();
    }
    $(".tableexport-caption").addClass("hidden");
  }

  const validateDate = async () => {
    let isValid = true;

    if (
      moment(selectedToDate, "DD-MM-YYYY").isBefore(
        moment(selectedFromDate, "DD-MM-YYYY")
      )
    ) {
      isValid = false;
      swal.fire({
        icon: "error",
        titleText: "Oops..",
        text: "To Date should be greater than From Date",
        buttonsStyling: false,
        confirmButtonClass: "btn btn-brand",
      });
      return;
    }
    if (isValid) {
      getTeeReport();
    }
  };

  return (
    <>
      <div
        className="kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor padding-tb0"
        id="kt_content"
      >
        <div className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid margin-t20">
          <div className="kt-portlet">
            <div className="kt-portlet__body padding-t20 padding-b0">
              <div
                id="ControlHolder"
                className="kt-form kt-form--label-right padding-10"
                role="form"
              >
                <div className="row">
                  <label className="col-form-label col-sm-1 text-right">
                    From Date
                  </label>
                  <div className="form-group col-sm-2">
                    <div className="input-group date">
                      <input
                        id="txtFromDate"
                        name="txtFromDate"
                        type="text"
                        className="form-control"
                        placeholder="Select date"
                        readOnly={true}
                        defaultValue={moment(
                          selectedFromDate,
                          "DD-MM-YYYY"
                        ).format("DD-MM-YYYY")}
                      />
                      <div className="input-group-append">
                        <span className="input-group-text">
                          <i className="la la-calendar-check-o"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                  <label className="col-form-label col-sm-1 text-right">
                    To Date
                  </label>
                  <div className="form-group col-sm-2">
                    <div className="input-group date">
                      <input
                        id="txtToDate"
                        name="txtToDate"
                        type="text"
                        className="form-control"
                        placeholder="Select date"
                        readOnly={true}
                        defaultValue={moment(
                          selectedFromDate,
                          "DD-MM-YYYY"
                        ).format("DD-MM-YYYY")}
                      />
                      <div className="input-group-append">
                        <span className="input-group-text">
                          <i className="la la-calendar-check-o"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-1">
                    <button
                      className="btn btn-label-success"
                      type="button"
                      id="btnSearch"
                      aria-haspopup="true"
                      aria-expanded="false"
                      onClick={() => validateDate()}
                    >
                      <i className="la la-search"></i>
                    </button>
                  </div>
                  <div className="form-group col-sm-2">
                    <div className="input-group">
                      <div className="kt-input-icon kt-input-icon--left">
                        <input
                          type="text"
                          className="form-control clientSearch"
                          placeholder="Search..."
                          id="generalSearch"
                        />
                        <span className="kt-input-icon__icon kt-input-icon__icon--left">
                          <span>
                            <i className="la la-search"></i>
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-1">
                    <div className="dropdown">
                      <button
                        className="btn btn-label-brand dropdown-toggle"
                        type="button"
                        id="dropdownMenuButton"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        Export
                      </button>
                      <div
                        className="dropdown-menu "
                        aria-labelledby="dropdownMenuButton"
                        x-placement="bottom-start"
                        style={{
                          position: "absolute",
                          willChange: "transform",
                          top: "0px",
                          left: "0px",
                          transform: "translate3d(0px, 38px, 0px)",
                        }}
                      >
                        <button
                          id="btn-export-excel"
                          type="button"
                          className="dropdown-item"
                          onClick={() => exportSheet("xlsx")}
                        >
                          {" "}
                          Excel
                        </button>
                        <button
                          id="btn-export-csv"
                          type="button"
                          className="dropdown-item"
                          onClick={() => exportSheet("csv")}
                        >
                          {" "}
                          Csv{" "}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <RevenueRateBar
                rateDetails={rateDetails}
                bookingDetails={bookingDetails}
              />
              <div
                id="tblTeeRevenueReport"
                className="table table-bordered table-hover custom-datatable"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RevenueReport;
